// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-menu {
  --background: #006184;
  --width: 309px;
}
ion-menu ion-header {
  --background: transparent;
}
ion-menu ion-header .header-background {
  display: none;
}
@media (min-width: 938px) {
  ion-menu ion-header ion-menu-toggle {
    display: none;
  }
}
ion-menu ion-content {
  --background: transparent;
}
ion-menu ion-content ion-menu-toggle {
  display: block;
  margin-bottom: 26px !important;
}
ion-menu ion-content ion-menu-toggle div > ion-button:first-child {
  margin-bottom: 31px !important;
}
ion-menu ion-content ion-menu-toggle div > ion-button:first-child + ion-button {
  margin-bottom: -7px !important;
}
ion-menu ion-content ion-menu-toggle p,
ion-menu ion-content ion-menu-toggle ion-button {
  display: block;
  text-align: left !important;
  color: #fff;
  font-size: 16px;
  height: auto;
  line-height: 22px !important;
  --padding-start: 17px;
  --padding-end: 17px;
  white-space: normal;
  margin-bottom: 27px !important;
}
ion-menu ion-content ion-menu-toggle p strong,
ion-menu ion-content ion-menu-toggle ion-button strong {
  display: block;
  font-size: 19px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  margin-top: -2.6px !important;
  line-height: 23px;
  margin-bottom: 1px !important;
}
ion-menu ion-content ion-menu-toggle p span,
ion-menu ion-content ion-menu-toggle ion-button span {
  width: 100%;
  line-height: 22px;
}
ion-menu ion-content ion-menu-toggle p + p,
ion-menu ion-content ion-menu-toggle ion-button + p {
  margin-top: 29px !important;
  margin-bottom: 12px !important;
}
ion-menu ion-content ion-menu-toggle p {
  padding-left: 17px !important;
  padding-right: 17px !important;
}
ion-menu ion-content ion-menu-toggle p span {
  font-size: 12px;
  text-transform: uppercase !important;
}
ion-menu .version {
  font-size: 1rem;
  --padding-start: 17px;
  --padding-end: 17px;
  position: absolute;
  bottom: 0;
}

.customToast {
  color: #fff;
  --background: radial-gradient(
    116.99% 133.82% at 62.8% -21.64%,
    #0693c6 0%,
    #01688d 67.64%,
    #006184 100%
  );
}

.customToast::part(button) {
  background-color: #fff;
  margin-right: 10px;
  border-radius: 10px;
  color: #006184;
}

.list::part(container),
.slideshow::part(container) {
  overflow: visible !important;
}`, "",{"version":3,"sources":["webpack://./src/app/app.component.scss"],"names":[],"mappings":"AAAA;EACE,qBAAA;EACA,cAAA;AACF;AAAE;EACE,yBAAA;AAEJ;AADI;EACE,aAAA;AAGN;AAAM;EADF;IAEI,aAAA;EAGN;AACF;AAAE;EACE,yBAAA;AAEJ;AADI;EACE,cAAA;EA+CA,8BAAA;AA3CN;AAFM;EACE,8BAAA;AAIR;AAHQ;EACE,8BAAA;AAKV;AAFM;;EAEE,cAAA;EACA,2BAAA;EACA,WAAA;EACA,eAAA;EACA,YAAA;EACA,4BAAA;EACA,qBAAA;EACA,mBAAA;EACA,mBAAA;EACA,8BAAA;AAIR;AAHQ;;EACE,cAAA;EACA,eAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,6BAAA;EACA,iBAAA;EACA,6BAAA;AAMV;AAJQ;;EACE,WAAA;EACA,iBAAA;AAOV;AALQ;;EACE,2BAAA;EACA,8BAAA;AAQV;AALM;EACE,6BAAA;EACA,8BAAA;AAOR;AANQ;EACE,eAAA;EACA,oCAAA;AAQV;AAFE;EACE,eAAA;EACA,qBAAA;EACA,mBAAA;EACA,kBAAA;EACA,SAAA;AAIJ;;AADA;EACE,WAAA;EACA;;;;;GAAA;AASF;;AAFA;EACE,sBAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;AAKF;;AAHA;;EAEE,4BAAA;AAMF","sourcesContent":["ion-menu {\n  --background: #006184;\n  --width: 309px;\n  ion-header {\n    --background: transparent;\n    .header-background {\n      display: none;\n    }\n    ion-menu-toggle {\n      @media (min-width: 938px) {\n        display: none;\n      }\n    }\n  }\n  ion-content {\n    --background: transparent;\n    ion-menu-toggle {\n      display: block;\n\n      div > ion-button:first-child {\n        margin-bottom: 31px !important;\n        + ion-button {\n          margin-bottom: -7px !important;\n        }\n      }\n      p,\n      ion-button {\n        display: block;\n        text-align: left !important;\n        color: #fff;\n        font-size: 16px;\n        height: auto;\n        line-height: 22px !important;\n        --padding-start: 17px;\n        --padding-end: 17px;\n        white-space: normal;\n        margin-bottom: 27px !important;\n        strong {\n          display: block;\n          font-size: 19px;\n          white-space: nowrap;\n          text-overflow: ellipsis;\n          overflow: hidden;\n          margin-top: -2.6px !important;\n          line-height: 23px;\n          margin-bottom: 1px !important;\n        }\n        span {\n          width: 100%;\n          line-height: 22px;\n        }\n        + p {\n          margin-top: 29px !important;\n          margin-bottom: 12px !important;\n        }\n      }\n      p {\n        padding-left: 17px !important;\n        padding-right: 17px !important;\n        span {\n          font-size: 12px;\n          text-transform: uppercase !important;\n        }\n      }\n      margin-bottom: 26px !important;\n    }\n  }\n  .version {\n    font-size: 1rem;\n    --padding-start: 17px;\n    --padding-end: 17px;\n    position: absolute;\n    bottom: 0;\n  }\n}\n.customToast {\n  color: #fff;\n  --background: radial-gradient(\n    116.99% 133.82% at 62.8% -21.64%,\n    #0693c6 0%,\n    #01688d 67.64%,\n    #006184 100%\n  );\n}\n.customToast::part(button) {\n  background-color: #fff;\n  margin-right: 10px;\n  border-radius: 10px;\n  color: #006184;\n}\n.list::part(container),\n.slideshow::part(container) {\n  overflow: visible !important;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
